import React, { ChangeEvent, MouseEventHandler, ReactElement } from 'react';

import { ARCHIVED } from '../../../../../utils/constants';

import { HashTag } from '../../../../../types/entity.types';

import Button from '../../../../common/button/Button';
import Checkbox from '../../../../common/input/checkbox/Checkbox';

import { ReactComponent as CloseIcon } from '../../../../../resources/icons/close.svg';

import './tribe-settings.scss';

type Props = {
  hashtags?: HashTag[];
  status: string;
  approvePosts?: boolean;
  setApprovePosts: (value: boolean) => void;
  approvePhotos?: boolean;
  setApprovePhotos: (value: boolean) => void;
  approveComments?: boolean;
  setApproveComments: (value: boolean) => void;
  onCreateHashtag: MouseEventHandler<HTMLButtonElement>;
  onUpdateHashtag: (id: string | number, value: string) => void;
  onDeleteHashtag: (id: string | number) => void;
};

const TribeSettings = ({
  hashtags = [],
  status,
  approvePosts = false,
  setApprovePosts,
  approvePhotos = false,
  setApprovePhotos,
  approveComments = false,
  setApproveComments,
  onCreateHashtag,
  onUpdateHashtag,
  onDeleteHashtag
}: Props): ReactElement => (
  <div className="tribe__settings">
    <div className="tribe__header">
      <h1>Admin Approval Needed For:</h1>
    </div>
    <div className="tribe__settings__inputs">
      <Checkbox
        label="All Posts"
        name="all-posts"
        value={approvePosts}
        onChange={setApprovePosts}
        disabled={status === ARCHIVED}
        left
      />
      <Checkbox
        label="Photos"
        name="photos"
        value={approvePhotos}
        onChange={setApprovePhotos}
        disabled={status === ARCHIVED}
        left
      />
      <Checkbox
        label="Comments"
        name="comments"
        value={approveComments}
        onChange={setApproveComments}
        disabled={status === ARCHIVED}
        left
      />
    </div>
    <div className="tribe__settings__hashtags">
      <h1>Hashtags</h1>
      <div className="tribe__settings__hashtags-list">
        {hashtags.map(
          (hashtag: HashTag): ReactElement => (
            <div
              className="tribe__settings__hashtags-list__hashtag"
              key={hashtag.id}
              data-testid="tribe-settings-hashtag"
            >
              <input
                value={hashtag.name}
                onChange={({ target }: ChangeEvent<HTMLInputElement>): void => {
                  onUpdateHashtag(hashtag.id ?? '', target.value);
                }}
              />
              <CloseIcon
                className="tribe__settings__hashtags-list__hashtag-delete-icon"
                onClick={(): void => {
                  if (!hashtag.id) return;

                  onDeleteHashtag(hashtag.id);
                }}
                data-testid="hashtag-delete-icon"
              />
            </div>
          )
        )}
      </div>
      <Button text="Add" onClick={onCreateHashtag} />
    </div>
  </div>
);

export default TribeSettings;
